import { Component, OnInit, Pipe, PipeTransform, inject } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {DomSanitizer, SafeHtml, SafeResourceUrl} from '@angular/platform-browser';
import {environment} from '../../environments/environment';
import {filter, map} from 'rxjs/operators';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.css'],
    imports: [MatCard, MatCardTitle, MatProgressSpinner, MatCardContent]
})
export class CheckoutComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);
  private router = inject(Router);
  private sanitizer = inject(DomSanitizer);


  encryptedData: Params;
  srcIframe : SafeResourceUrl;
  errTxt: string;
  error = false;
  isLoading = true;
  apiUrl = environment.apiUrl;
  alertAgence = false;

  constructor() {
    this.route.params.subscribe( (params) => {
        this.encryptedData = params;
      });
  }

  ngOnInit(): void {
   if (this.encryptedData.id === 'error') {
      this.displayError();
    } else {
      localStorage.removeItem('err_checkout');
      this.callApiPaymentCB();
    }
  }

  callApiPaymentCB(): void {
    this.http.post(this.apiUrl + '/checkout/get-checkout', this.encryptedData.id, {
      observe: 'response',
      responseType: 'text'
    })
      .pipe(
        filter((res: HttpResponse<string>) => res.ok),
        map((res: HttpResponse<string>) => res.body)
      )
      .subscribe((response: string) => {
        this.srcIframe = this.sanitizer.bypassSecurityTrustResourceUrl(response);
        this.isLoading = false;
      }, (error: string) => {
        localStorage.setItem('err_checkout', error);
        this.displayError();
        this.router.navigateByUrl('paiement/checkout/error').then();
      });
  }

  private displayError(): void {
    const codeError = localStorage.getItem('err_checkout');

    switch (codeError) {
      case 'ERR_FACTURE_NOT_FOUND':
        this.errTxt = 'Cette facture n\'est plus disponible au paiement CB';
        this.alertAgence = true;
        break;
      case 'ERR_ORDER_ALREADY_PAID':
        this.errTxt = 'Cette facture est déjà payée';
        break;
      case 'ERR_PAYS_CLIENT':
        this.errTxt = 'Il y a une incohérence entre les informations au niveau du pays dans notre système d\'information,' +
          ' vous êtes considéré comme entreprise française alors que non.' +
          ' Merci de vous rapprocher de votre agence pour régulariser la situation.';
        break;
      case 'ERR_MARCHAND_NOT_FOUND' :
      case 'ERR_CLIENT_NOT_FOUND':
      case 'ERR_GET_SRC_IFRAME':
      case 'ERR_DECRYPT_DATA':
      case 'ERR_INVALID_DATA':
      case 'ERR_ORDER_NOT_FOUND':
      case 'ERR_ENV_MONETICO':
      default:
        this.errTxt = 'Un problème technique s\'est produit, actuellement nous ne pouvons pas vous fournir le service';
        this.alertAgence = true;
        break;
    }

    this.error = true;
    this.isLoading = false;
  }
}

@Pipe({ name: 'noSanitize' })
export class NoSanitizePipe implements PipeTransform {
  private domSanitizer = inject(DomSanitizer);

  transform(html: string): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }
}
